"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputSearchStyle = void 0;
const sectionListStyles = {
    tabBar: {
        width: '100%',
        backgroundColor: '#fff',
        borderBottomColor: '#f4f4f4',
        borderBottomWidth: 1,
        borderTopColor: '#bebebe',
    },
    tabContainer: {
        marginLeft: 2.5,
        marginRight: 2.5,
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
        paddingLeft: 5,
        paddingRight: 5,
    },
    tabText: {
        color: '#9e9e9e',
        fontSize: 18,
        fontWeight: '500',
    },
    sectionHeaderText: {
        color: '#010101',
        fontSize: 23,
        fontWeight: 'bold',
        paddingHorizontal: 5,
    },
};
exports.inputSearchStyle = {
    marginLeft: 15,
    marginRight: 15,
    width: '100%',
    height: 50,
    color: 'black',
};
exports.default = sectionListStyles;
